import React, { useEffect, useState, useCallback } from "react";
// Import Routing Components For Linking to Web pages
import { Link, useNavigate} from "react-router-dom";
import Swal from "sweetalert2";
import { getErrorMessage } from "../../services/errorHelper";
import apiClient, { getCurrentUserId } from "../../services/apiClient";
import { FaEllipsisV } from "react-icons/fa";
// COMPONENTS


function ContractFormMain() {
  const [contactForms, SetContactForms] = useState([]);
  const [selectedContactForm, SetSelectedContactForm] = useState(null);
  const [menuVisible, setMenuVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
      const fetchContactForm = async () =>{
        try {
          const response = await apiClient.post('/contactFormsList', {user_id: getCurrentUserId()});
          SetContactForms(response.data);
        } catch (error) {
        console.error("Error fetching contracts:", error);
        }
      };
      fetchContactForm();
  }, []);

  const handleEdit = useCallback((emailId) => {
      navigate(`/edit-contact/${emailId}`);
    }, [navigate]);
  
  const handleDelete = async (contactId) => {

    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
        customClass: {
          popup: 'swal-top-zindex'
        }
      });
  
      if (result.isConfirmed) {
        const response = await apiClient.post(`/deleteContactForm/${contactId}`);
        SetContactForms(contactForms.filter((contactForms) => contactForms.id !== contactId));
        Swal.fire("Deleted!", "Contract has been deleted.", "success");
      }
    } catch (error) {
      console.error(`Failed to delete Contract with ID ${contactId}:`, error);
      Swal.fire("Error", getErrorMessage(error, "Failed to delete Contract."), "error");
    }
  };

  const handleEmbed = async (contactId, contactSlug) => {
    try {
      const directLink = `https://app.eventtrackit.com/showContactForm/${contactSlug}`;  //  direct link
        const embedScript = `<iframe src="https://app.eventtrackit.com/showContactForm/${contactSlug}" frameborder="0" width="600" height="400"></iframe>`; //  embed code

        const htmlContent = `
            <div>
                <p><strong>Direct Link:</strong> 
                    <input type="text" value="${directLink}" id="directLink" class="swal2-input" readonly />
                </p>
                <p><strong>Embed Code:</strong> 
                    <textarea id="embedCode" class="swal2-textarea" readonly>${embedScript}</textarea>
                </p>
            </div>
        `;
      const result = await Swal.fire({
        title: "Embed",
        text: "You Can Use Direct Link Or Use Code To Embed On Your Website.",
        icon: "info",
        html: htmlContent,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: `<i class="fa fa-thumbs-up"></i> Great!`,
        confirmButtonAriaLabel: "Thumbs up, great!",
        customClass: {
          popup: 'swal-top-zindex'
        }
      });
      
    }catch(error){

    }
  };
  
    const toggleMenu = (email) => {
      SetSelectedContactForm(email);
      setMenuVisible(!menuVisible);
    };
  

  return (
    //  ================= *****  TEMPLATES BODY JSX ***** =================
    <>
      <div className='container-fluid p-lg-5 p-md-5 p-3'>
        <div className='row g-lg-5 g-md-5 g-3'>
          <div className='col-sm-12 col-md-12 col-xl-12'>
            <div className='mb-4'>
              <h3 className='mb-1'>Contact Form</h3>
              <p>
                Get booked faster! Create Contact Forms to make it easy for
                clients to get in touch. Submissions <br /> will funnel right
                into events funnel.
              </p>
            </div>
          </div>
          {/* ========= Create a New Product Button ========= */}
          <div className='col-sm-12 col-md-6 col-xl-4 product-items'>
            <div className='h-100 bg-white rounded p-3 shadow-sm'>
              <Link
                to='/new-contact'
                id=''
                className='h-100 d-flex align-items-center justify-content-center px-2 py-5 p-urls'
                style={{ border: "1px dashed #534dbb" }}>
                <div className='mb-4 text-center'>
                  <i
                    className='fa-solid fa-plus'
                    style={{ fontSize: "70px" }}></i>
                  <h6 className='mb-0 fw-bold text-uppercase'>
                    CREATE A NEW CONTACT FORM
                  </h6>
                </div>
              </Link>
            </div>
          </div>

          {/* ========= Basic Photo Booth Contract Button ========= */}
          {contactForms.map((contact) => (
                      <div key={contact.id} id='' className='col-sm-12 col-md-6 col-xl-4 contact-items'>
                        <div className='h-100 bg-white d-flex align-items-center justify-content-center rounded p-4 shadow-sm position-relative product-items2' onClick={() => handleEdit(contact.id)}>
                          <div className='three-dot-btn'>
                            <div className='position-absolute top-0 end-0 me-3 mt-2'>
                              <button className='border-0 bg-transparent ' type='button'>
                                <div id='p-dot' style={{ position: "relative", zIndex: 10000 }} onMouseEnter={() => toggleMenu(contact)}
            onMouseLeave={() => toggleMenu(null)}>
                                  <FaEllipsisV style={{ cursor: "pointer" }} />
                                  {menuVisible && selectedContactForm === contact && (
                                    <div
                                      className='position-absolute bg-white shadow-sm rounded'
                                      style={{
                                        top: "20px",
                                        right: "0",
                                        zIndex: "10",
                                      }}>
                                      <button
                                        className='dropdown-item'
                                        onClick={() => handleEdit(contact.id)}>
                                        Edit
                                      </button>

                                      <button
                                        className='dropdown-item'
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleEmbed(contact.id, contact.slug)
                                        }
                                        }>
                                        Embed
                                      </button>

                                      <button
                                        className='dropdown-item'
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleDelete(contact.id)
                                        }
                                        }>
                                        Delete
                                      </button>
                                    </div>
                                  )}
                                </div>
                              </button>
                            </div>
                            <div className='text-center edit-btn'>
                              <button className='border-0 bg-transparent' type='button'>
                                <i className='fa-solid fa-file-signature'></i>
                              </button>
                              <p className='basic-photo'>
                                {contact.title.toUpperCase()}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
        </div>
      </div>
    </>

    // ================= *****  TEMPLATES BODY JSX ***** =================
  );
}

export { ContractFormMain }; /* ========================= We had to remove default. */
